import React from "react";
import { MainContainer } from "../styles/sharedStyles"; // Import shared styles
import Title from "../../components/title/Title";
import TextParagraph from "../../components/text/TextParagraph";

const CoachingMusculation = () => {
  return (
    <MainContainer>
      <Title
        title="Coaching Musculation"
        summary="Ton plan d'entraînement sur-mesure pour progresser efficacement en salle."
      />

      <TextParagraph
        content={`<p>Prêt(e) à transformer tes entraînements et progresser à ton rythme ? 💪</p>`}
      />

      <TextParagraph
        content={`<p>Ce que comprend ton coaching musculation :</p>
        <ul>
          <li>✅ <strong>Plan d'entraînement sur-mesure :</strong> chaque séance est adaptée à ton niveau, tes objectifs et ton emploi du temps (fini les programmes généralistes !).</li>
          <li>✅ <strong>Échanges via WhatsApp :</strong> je suis disponible pour te conseiller, ajuster les exercices ou simplement te motiver.</li>
          <li>✅ <strong> Bilan hebdomadaire :</strong> chaque semaine, on fait le point ensemble pour ajuster et améliorer tes résultats.</li>
        </ul>`}
      />

      <TextParagraph
        content={`<p>Tu pourras aussi échanger dans un groupe avec d’autres membres pour partager tes réussites, poser des questions et rester motivé(e). Team spirit au max ! 🔥</p>`}
      />
    </MainContainer>
  );
};

export default CoachingMusculation;
